import { Button, Modal } from '@servicetitan/design-system';
import { ModalSizes } from '@servicetitan/design-system/dist/components/Modal/components';
import DiagnosticsModule from '..';
import { useDiagnostics } from '../DiagnosticsContext';

const DiagnosticsModal = () => {
  const { errors } = useDiagnostics();

  const modalErrors = errors.filter(
    (error) => error.priority === 'modal' && !error.read,
  );

  const handleClose = () => {
    DiagnosticsModule.markErrorsAsRead(['modal']);
  };

  return (
    <Modal
      open={modalErrors.length > 0}
      size={ModalSizes.XS}
      title={'Error'}
      backdrop
      onClose={handleClose}
      footer={<Button onClick={handleClose}>Dismiss</Button>}
      datra-testid='diagnostics-modal'
    >
      {modalErrors.map((error) => (
        <div key={error.id} data-testid='diagnostics-modal-item'>
          {error.message}
        </div>
      ))}
    </Modal>
  );
};

export default DiagnosticsModal;
